export default __webpack_public_path__ + "static/media/read.a1d35b98.svg";